import React, { FC } from 'react';
import LockIcon from '@mui/icons-material/Lock';
import classes from '@/components/SideBar.module.css';

const LockIndicator: FC = (): JSX.Element => <LockIcon className={classes.lockIcon} />;
export default LockIndicator;
